import { PdInputFile } from "./pd-input-file/PdInputFile.js";
//#region src/pd-input-file/pd-input-file.ts
var tag = "pd-input-file";
if (!customElements.get(tag)) customElements.define(tag, PdInputFile);
//#endregion
export { PdInputFile };
